import { render, staticRenderFns } from "./AddressAccordion.vue?vue&type=template&id=33bd0a8c&scoped=true"
import script from "./AddressAccordion.vue?vue&type=script&lang=js"
export * from "./AddressAccordion.vue?vue&type=script&lang=js"
import style0 from "./AddressAccordion.css?vue&type=style&index=0&id=33bd0a8c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd0a8c",
  null
  
)

export default component.exports